import TeacherAgreementBlock from './TeacherAgreementBlock';
import { TeacherAgreementBlockProps, TeacherAgreementBlockValueProps } from './types';

export type { TeacherAgreementBlockProps, TeacherAgreementBlockValueProps };
export default TeacherAgreementBlock;
